import React, { useEffect } from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';
import { useAppContext } from 'context';
import { useHistory } from 'react-router-dom';

const Nav = (props) => {
  const history = useHistory();
  const { clist } = props;
  const {
    dispatch,
    state: { type },
  } = useAppContext();

  useEffect(() => {
    // 缓慢滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [type]);

  const onClick = (v) => {
    dispatch({ type: 'SET_PRODUCT_TYPE', payload: v });
    // 切换不同类别时，重置当前页码
    if (type !== v) {
      dispatch({ type: 'SET_PRODUCT_CURRENT_PAGE', payload: 1 });
    }
    history.push('/productCenter');
  };

  return (
    <QueueAnim
      className={clsx('product-center-content-left')}
      type={['left', 'right']}
    >
      <div
        className={clsx('product-center-content-left-title')}
        key='product-center-content-left-title'
      >
        产品中心
      </div>
      <div
        className={clsx('product-center-content-left-content')}
        key='product-center-content-left-content'
      >
        {clist?.map((v, index) => {
          return (
            <div
              className={clsx('product-center-content-left-content-item', {
                isProductActive: type === v.cid,
              })}
              key={index}
              onClick={() => onClick(v.cid)}
            >
              <div
                className={clsx(
                  'product-center-content-left-content-item-text',
                )}
              >
                {v.name}
                {/* 右箭头 */}
                <svg
                  viewBox='64 64 896 896'
                  focusable='false'
                  data-icon='right'
                  width='12px'
                  height='12px'
                  fill='currentColor'
                  aria-hidden='true'
                  className={clsx('product-svg')}
                >
                  <path d='M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z'></path>
                </svg>
              </div>
            </div>
          );
        })}
      </div>
    </QueueAnim>
  );
};

export default Nav;
